import track, {
  trackFacebook,
  trackGA,
  ONBOARDING_CREATE_PROJECT
} from 'utils/analytics';
import { WizardStep } from './types';

// Every variant event is tagged with the arm + the org's active experiments so
// it can be compared against the control arm in the funnel.
const armProps = (activeExperiments: string[]) => ({
  onboarding_arm: 'q22026_onboarding_variant',
  experiments: activeExperiments.join(',')
});

const STEP_EVENT: Record<WizardStep, string> = {
  [WizardStep.YOUR_PROJECT]: 'Onboarding Step 1',
  [WizardStep.INSTALL]: 'Onboarding Step 2',
  [WizardStep.TRY]: 'Onboarding Step 3'
};

export const trackVariantStepView = (
  step: WizardStep,
  activeExperiments: string[],
  email?: string
) => {
  track(STEP_EVENT[step], armProps(activeExperiments));

  // Mirror the control flow, which treats reaching Step 3 as the widget being
  // installed / the user being ready to give feedback.
  if (step === WizardStep.TRY) {
    trackFacebook('Widget Installed');
    trackGA({ event: 'widget installed', email });
  }
};

export const trackVariantCreateProject = (activeExperiments: string[]) =>
  track(ONBOARDING_CREATE_PROJECT, armProps(activeExperiments));
